// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import MarshallIslands from '../_raw/flag/icon_flag_marshall_islands.png';

export default () => <img src={MarshallIslands} alt="MarshallIslands" />;
